/**
 * elec.ts — Categoría "Electrodomésticos" (10 productos demo).
 */
import { buildProduct } from "./_factory";
import type { Producto } from "@/types";

const CAT = {
  categoryId: "cat_elec",
  skuPrefix: "ELE",
  categoria: "Electrodomésticos",
} as const;

export const cat_elec_products: Producto[] = [
  buildProduct({
    ...CAT,
    index: 0,
    nombre: "Nevera No Frost 400L",
    marca: "LG",
    modelo: "GT40WPPDC",
    origen: "Corea",
    costo: 1850000,
    precio: 2790000,
    stock: 8,
    stockMinimo: 2,
    stockMaximo: 16,
    unidad: "unidad",
    ubicacionFisica: "Showroom E1",
    proveedor: "LG Electronics Colombia",
    garantia: "10 años compresor",
    tiempoEntrega: "5 días",
    material: "Acero y plástico ABS",
    colorProducto: "Plata",
    dimensiones: "70x68x170cm",
    descripcionLarga:
      "Nevera No Frost 400L con compresor inverter linear, enfriamiento multi-flow y dispensador interno de agua.",
    especificaciones: [
      { clave: "Capacidad", valor: "400L" },
      { clave: "Eficiencia", valor: "A+" },
    ],
    imageKeywords: ["refrigerator", "lg-fridge", "no-frost"],
    color: "bg-slate-300",
    shape: "square",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 1,
    nombre: "Lavadora 18kg LG",
    marca: "LG",
    modelo: "WT18DSB6",
    origen: "Corea",
    costo: 1450000,
    precio: 2190000,
    stock: 10,
    stockMinimo: 3,
    stockMaximo: 20,
    unidad: "unidad",
    ubicacionFisica: "Showroom E1",
    proveedor: "LG Electronics Colombia",
    garantia: "10 años motor",
    tiempoEntrega: "5 días",
    material: "Acero inoxidable",
    colorProducto: "Blanco",
    dimensiones: "70x73x102cm",
    descripcionLarga:
      "Lavadora carga superior 18kg, motor inverter direct drive. 14 programas, tecnología TurboDrum, WiFi.",
    especificaciones: [
      { clave: "Capacidad", valor: "18kg" },
      { clave: "Programas", valor: "14" },
    ],
    imageKeywords: ["washing-machine", "lg-washer", "laundry"],
    color: "bg-white",
    shape: "square",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 2,
    nombre: "Estufa 4 Puestos Gas",
    marca: "Haceb",
    modelo: "Assento Futura",
    origen: "Colombia",
    costo: 585000,
    precio: 899000,
    stock: 12,
    stockMinimo: 3,
    stockMaximo: 24,
    unidad: "unidad",
    ubicacionFisica: "Showroom E2",
    proveedor: "Haceb S.A.",
    garantia: "2 años",
    material: "Acero inoxidable",
    colorProducto: "Inox",
    dimensiones: "60x60x88cm",
    descripcionLarga:
      "Estufa gas 4 puestos + horno 60cm. Encendido electrúnico, parrilla hierro fundido. Apagado automático.",
    especificaciones: [
      { clave: "Puestos", valor: "4" },
      { clave: "Horno", valor: "60L" },
    ],
    imageKeywords: ["gas-stove", "kitchen-range", "haceb"],
    color: "bg-slate-300",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 3,
    nombre: "Microondas 1.1 cu ft",
    marca: "Samsung",
    modelo: "MS32J5133",
    origen: "Tailandia",
    costo: 385000,
    precio: 589000,
    stock: 18,
    stockMinimo: 5,
    stockMaximo: 36,
    unidad: "unidad",
    ubicacionFisica: "Showroom E3",
    proveedor: "Samsung Electronics Colombia",
    garantia: "1 año",
    material: "Acero",
    colorProducto: "Negro",
    dimensiones: "51x39x30cm",
    descripcionLarga:
      "Microondas 32L, 1000W. 20 preajustes automáticos, modo ceramic enamel higiúnico y descongelado rápido.",
    especificaciones: [
      { clave: "Capacidad", valor: "32L" },
      { clave: "Potencia", valor: "1000W" },
    ],
    imageKeywords: ["microwave", "samsung-microwave", "kitchen-appliance"],
    color: "bg-slate-900",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 4,
    nombre: "Licuadora Oster 10 Vel",
    marca: "Oster",
    modelo: "BRLY07",
    origen: "México",
    costo: 125000,
    precio: 195000,
    stock: 25,
    stockMinimo: 6,
    stockMaximo: 50,
    unidad: "unidad",
    ubicacionFisica: "Showroom E3",
    proveedor: "Oster Colombia",
    garantia: "3 años motor",
    material: "Vidrio y plástico",
    colorProducto: "Negro",
    dimensiones: "1.5L jarra",
    descripcionLarga:
      "Licuadora clásica Oster con jarra vidrio 1.5L, 10 velocidades y cuchillas acero inoxidable. Motor potente 600W.",
    especificaciones: [
      { clave: "Potencia", valor: "600W" },
      { clave: "Jarra", valor: "1.5L vidrio" },
    ],
    imageKeywords: ["blender", "oster-blender", "kitchen-blender"],
    color: "bg-slate-900",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 5,
    nombre: "Freidora Aire Oster",
    marca: "Oster",
    modelo: "Air Fryer 4L",
    origen: "China",
    costo: 285000,
    precio: 439000,
    stock: 20,
    stockMinimo: 5,
    stockMaximo: 40,
    unidad: "unidad",
    ubicacionFisica: "Showroom E3",
    proveedor: "Oster Colombia",
    garantia: "1 año",
    material: "Plástico y acero",
    colorProducto: "Negro",
    dimensiones: "4L",
    descripcionLarga:
      "Freidora de aire 4L con tecnología rapid air, 8 programas predefinidos. Cocina saludable sin aceite.",
    especificaciones: [
      { clave: "Capacidad", valor: "4L" },
      { clave: "Programas", valor: "8" },
    ],
    imageKeywords: ["air-fryer", "oster-fryer", "kitchen-fryer"],
    color: "bg-slate-900",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 6,
    nombre: "Cafetera Expreso",
    marca: "Nespresso",
    modelo: "Essenza Mini",
    origen: "Suiza",
    costo: 385000,
    precio: 589000,
    stock: 15,
    stockMinimo: 4,
    stockMaximo: 30,
    unidad: "unidad",
    ubicacionFisica: "Showroom E3",
    proveedor: "Nespresso Colombia",
    garantia: "2 años",
    material: "Plástico ABS",
    colorProducto: "Negro mate",
    descripcionLarga:
      "Cafetera cápsulas Nespresso compacta 19 bar, calentamiento rápido 25 seg. 2 tamaños taza.",
    especificaciones: [
      { clave: "Presión", valor: "19 bar" },
      { clave: "Tanque", valor: "0.6L" },
    ],
    imageKeywords: ["coffee-machine", "nespresso", "espresso-maker"],
    color: "bg-slate-900",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 7,
    nombre: "Aspiradora Robot",
    marca: "iRobot",
    modelo: "Roomba 692",
    origen: "China",
    costo: 985000,
    precio: 1499000,
    stock: 8,
    stockMinimo: 2,
    stockMaximo: 16,
    unidad: "unidad",
    ubicacionFisica: "Showroom E4",
    proveedor: "iRobot Colombia",
    garantia: "1 año",
    material: "Plástico ABS",
    colorProducto: "Negro",
    descripcionLarga:
      "Robot aspirador con conectividad WiFi, control app, 90min autonomía. Sistema 3 etapas, ideal alfombras y duros.",
    especificaciones: [
      { clave: "Autonomía", valor: "90 min" },
      { clave: "WiFi", valor: "Sí" },
    ],
    imageKeywords: ["robot-vacuum", "roomba", "smart-cleaner"],
    color: "bg-slate-900",
    shape: "circle",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 8,
    nombre: "Plancha Vapor Philips",
    marca: "Philips",
    modelo: "Azur GC4567",
    origen: "China",
    costo: 185000,
    precio: 289000,
    stock: 22,
    stockMinimo: 6,
    stockMaximo: 44,
    unidad: "unidad",
    ubicacionFisica: "Showroom E4",
    proveedor: "Philips Colombia",
    garantia: "2 años",
    material: "Cerámica y plástico",
    colorProducto: "Azul",
    descripcionLarga:
      "Plancha vapor 2600W suela SteamGlide Advanced. Golpe de vapor 220g, vapor continuo 50g/min, auto-apagado.",
    especificaciones: [
      { clave: "Potencia", valor: "2600W" },
      { clave: "Vapor", valor: "50g/min" },
    ],
    imageKeywords: ["steam-iron", "philips-iron", "clothes-iron"],
    color: "bg-blue-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 9,
    nombre: "Calentador Agua Eléctrico",
    marca: "Haceb",
    modelo: "Eterno 33L",
    origen: "Colombia",
    costo: 385000,
    precio: 589000,
    stock: 12,
    stockMinimo: 3,
    stockMaximo: 24,
    unidad: "unidad",
    ubicacionFisica: "Showroom E2",
    proveedor: "Haceb S.A.",
    garantia: "3 años tanque",
    material: "Acero vitrificado",
    colorProducto: "Blanco",
    dimensiones: "33L",
    descripcionLarga:
      "Calentador acumulación 33L, resistencia blindada, termostato ajustable. Eficiencia energética mejorada.",
    especificaciones: [
      { clave: "Capacidad", valor: "33L" },
      { clave: "Potencia", valor: "1500W" },
    ],
    imageKeywords: ["water-heater", "electric-heater", "haceb-heater"],
    color: "bg-white",
    shape: "circle",
  }),
];
